export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/agenda-c411a67eb76ab9a7ad26ca5d19b61392.png";